module.exports = __webpack_public_path__ + "static/media/goosht charkh karde.68145381.png";